import Services from '../Service'

// Recurso singleton: a tela edita sempre a mesma linha de INTEGRACOES
// (NOME_EMPRESA = 'Catalogo'), por isso não há id na URL.
class AdminIntegracaoService extends Services {
  constructor() {
    super()
    this.resource = 'admin/integracao'
  }

  async getIntegracao() {
    return await this.getAPI(this.resource)
  }

  async updateIntegracao(payload) {
    try {
      const { data } = await this._http.put(this.resource, { ...payload })
      return data
    } catch (e) {
      return this.handlingError(e)
    }
  }
}

export default new AdminIntegracaoService()
